// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cookie-banner[data-v-6545e9fe]{background:#fff;border-top:2px solid #ffdd57;bottom:0;box-shadow:0 -2px 10px rgba(0,0,0,.1);left:0;padding:1rem;position:fixed;right:0;z-index:100}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
